export default __webpack_public_path__ + "static/media/right-arrow-orange.eb2e2c7c.svg";